<template>
  <question-card hide-button>
    <template #title>
      {{UIComponentData.Header.Translations[questionnaireLead.Language]}}
    </template>
    <answer-icon-block>
      <answer-icon
        @click="answer(purchase)"
        image="purchase.svg"
        :checked="questionnaireLead.LoanPurpose === purchase"
      >
        {{UIComponentData.Choice1.Translations[questionnaireLead.Language]}}
      </answer-icon>
      <answer-icon
        @click="answer(refinance)"
        image="refinance.svg"
        :checked="questionnaireLead.LoanPurpose === refinance"
      >
        {{UIComponentData.Choice2.Translations[questionnaireLead.Language]}}
      </answer-icon>
      <answer-icon
        @click="answer(homeequity)"
        image="homeequity.svg"
        :checked="questionnaireLead.LoanPurpose === homeequity"
      >
        {{UIComponentData.Choice3.Translations[questionnaireLead.Language]}}
      </answer-icon>
    </answer-icon-block>
  </question-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import QuestionCard from '@/components/QuestionCard.vue';
import AnswerIcon from '@/components/AnswerIcon.vue';
import AnswerIconBlock from '@/components/AnswerIconBlock.vue';

export default {
  name: 'purpose-step',
  components: {
    QuestionCard,
    AnswerIcon,
    AnswerIconBlock,
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
    UIId: Number
  },
  computed: {
    ...mapGetters(['questionnaireLead']),
  },
  data: () => ({
    purchase: 'Purchase',
    refinance: 'Refinance',
    homeequity : 'Home Equity'
  }),
  methods: {
    ...mapActions(['mutateLead']),
    async answer(value) {
      this.questionnaireLead.LoanPurpose = value;
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
          this.$emit('route-to-next-slide',true);
        }
        else{
          this.$emit('route-to-next-slide',false);
        }
      }
    },
  },
};
</script>